import React, { Component } from 'react';

import InputWrapper from '../../../../components/Common/InputWrapper';
import NowInput from '../../../../components/Common/NowInput';
import { trans } from '../../../../localization/index';
import GroupWrapper from '../../../../components/Common/GroupWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import { COMMON_CONST } from '../../../../constants/constants';
import { isEmpty } from '../../../../utils/utils';

class WalletRestaurantInfo extends Component {
  render() {
    const {
      restaurant,
      restaurantName,
      customerName,
      restaurantEmail,
      restaurantPhone,
      restaurantAddress,
      handleChangeRestaurant,
      unlinkedRestaurants,
      isSubmit,
      handleChangeInput,
    } = this.props;
    const restaurantOptions = !isEmpty(unlinkedRestaurants)
      ? unlinkedRestaurants.map(res => ({
          value: res.restaurant_id,
          label: res.name,
          data: res,
        }))
      : [];
    return (
      <React.Fragment>
        <InputWrapper
          label={trans('merchant_wallet_add_choose_restaurant')}
          required
        >
          <NowSelect
            value={restaurant}
            options={restaurantOptions}
            isClearable={false}
            onChange={handleChangeRestaurant}
            required={isSubmit}
            placeholder={trans('merchant_wallet_add_choose_restaurant_holder')}
          />
        </InputWrapper>
        <InputWrapper
          label={trans('merchant_wallet_add_restaurant_name')}
          required
        >
          <NowInput
            value={restaurantName}
            onChange={evt =>
              handleChangeInput({ restaurantName: evt.target.value })
            }
            name="restaurantName"
            required={isSubmit}
            placeholder={trans('merchant_wallet_add_restaurant_name_holder')}
          />
        </InputWrapper>
        <GroupWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_customer_name')}
          >
            <NowInput
              value={customerName}
              onChange={evt =>
                handleChangeInput({ customerName: evt.target.value })
              }
              name="customerName"
              placeholder={trans('merchant_wallet_add_customer_name_holder')}
            />
          </InputWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_restaurant_email')}
          >
            <NowInput
              value={restaurantEmail}
              onChange={evt =>
                handleChangeInput({ restaurantEmail: evt.target.value })
              }
              name="restaurantEmail"
              email
              placeholder={trans('rebranding.merchant_wallet_add_restaurant_email_holder')}
            />
          </InputWrapper>
          <InputWrapper
            width="33.3%"
            label={trans('merchant_wallet_add_restaurant_phone')}
          >
            <NowInput
              value={restaurantPhone}
              onChange={evt =>
                handleChangeInput({ restaurantPhone: evt.target.value })
              }
              name="restaurantPhone"
              phone
              isNumberFormat
              numberFormatProps={{
                format: COMMON_CONST.FormatPhoneNumber,
                mask: '',
              }}
              placeholder={trans('merchant_wallet_add_restaurant_phone_holder')}
            />
          </InputWrapper>
        </GroupWrapper>
        <InputWrapper
          label={trans('merchant_wallet_add_restaurant_address')}
          required
        >
          <NowInput
            value={restaurantAddress}
            onChange={evt =>
              handleChangeInput({ restaurantAddress: evt.target.value })
            }
            name="restaurantAddress"
            required={isSubmit}
            placeholder={trans('merchant_wallet_add_restaurant_address_holder')}
          />
        </InputWrapper>
      </React.Fragment>
    );
  }
}

export default WalletRestaurantInfo;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/components/WalletRestaurantInfo.jsx